export default __webpack_public_path__ + "static/media/ff-logo-dark.781a4b19.png";